import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import { PaxItem } from './PaxItem'
import { PaxInfoMainDisplay as PaxInfoMobile } from './mobile/PaxInfoMainDisplay';
import styles from '../styles';

const StyledTableHead = withStyles(() => ({
  root: {
    display: 'table-header-group',
    fontSize: '0.875rem',
    borderBottom: '2px solid rgba(201, 195, 195, 1)',
    textAlign: 'left',
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: '0.01071em'
  }  
}))(TableRow);

const PaxHeaders = (props) => {
  const isMobile = props.isMobile
  const classes = props.classes

  if (isMobile) {
    return (
      <TableRow>
        <TableCell className={classes.tableCellLessPad} align="center">Name</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">RLOC</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Facts</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Checked In</TableCell>
      </TableRow>
    )
  }
  else {
    return (
      <TableRow>
        {/* <TableCell className={classes.tableCellLessPad} align="center">Remarks</TableCell> */}
        <TableCell className={classes.tableCellLessPad} align="center">Name</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">RLOC</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Type/Seg. Status</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Phone Number</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Pax Weight</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Facts</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">Fare Class</TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">No Show</TableCell>
        <TableCell className={classes.tableCellLessPad} style={{paddingRight: '6px'}} align="center">Checked In</TableCell>
      </TableRow>
    )
  }
}

export const PaxList = (props) => {
  const {flight, rowPax, modalClasses, isMobile, newTexts} = props;
  const classes = styles();

  return (
    <TableContainer>
      <Table size="small" aria-label="a dense table" sx={{
        '& .MuiTableCell-root':{
          padding: '2px'
        }
      }}>
        <StyledTableHead>
          <PaxHeaders isMobile={isMobile} classes={classes} />
        </StyledTableHead>
        <TableBody>
          {rowPax.map((pax, index) => (
            isMobile ? <PaxInfoMobile pax={pax} classes={classes} modalClasses={modalClasses} newTexts={newTexts} /> : <PaxItem pax={pax} flight={flight} newTexts={newTexts} key={index} classes={classes} modalClasses={modalClasses} isMobile={isMobile} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}